import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useCreateBlogTag } from "../../hooks/blog-tags/useCreateBlogTag";
import { useUpdateBlogTag } from "../../hooks/blog-tags/useUpdateBlogTag";
import FormInput from "../inputs/FormInput";
import LanguageToggle from "../global/LanguageToggle";

const FormAddEditBlogTag = ({ currentData, isEdit = false, onSubmitSuccess }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");
    const initialLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";
    const [activeLang, setActiveLang] = useState(initialLang.startsWith("ar") ? "ar" : "en");

    const [titleAr, setTitleAr] = useState("");
    const [titleEn, setTitleEn] = useState("");

    const { createBlogTagMutate, isPending: isCreating } = useCreateBlogTag();
    const { updateBlogTagMutate, isPending: isUpdating } = useUpdateBlogTag();

    const loadingSubmit = isCreating || isUpdating;

    useEffect(() => {
        if (isEdit && currentData) {
            setTitleAr(currentData?.title?.ar || "");
            setTitleEn(currentData?.title?.en || "");
        }
    }, [isEdit, currentData]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            title: { ar: titleAr || titleEn, en: titleEn || titleAr },
        };

        if (isEdit) {
            updateBlogTagMutate({ id: currentData.id, data: payload });
        } else {
            createBlogTagMutate(payload);
        }

        if (onSubmitSuccess) onSubmitSuccess();
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="h6">
                        {isEdit ? (isArabic ? "تعديل الوسم" : "Edit Tag") : (isArabic ? "إضافة وسم جديد" : "Add New Tag")}
                    </Typography>
                    <LanguageToggle activeLang={activeLang} onChange={(lng) => setActiveLang(lng)} showLabel={true} />
                </Box>

                <Grid container spacing={3}>
                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput label="الوسم (عربي)" placeholder="أدخل الوسم بالعربي" value={titleAr} onChange={(e) => setTitleAr(e.target.value)} required fullWidth />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput label="Tag (English)" placeholder="Enter tag in English" value={titleEn} onChange={(e) => setTitleEn(e.target.value)} required fullWidth />
                        </Grid>
                    )}
                </Grid>

                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button type="submit" variant="contained" disabled={loadingSubmit} sx={{ minWidth: 120 }}>
                        {loadingSubmit ? (isArabic ? "جاري الحفظ..." : "Saving...") : (isArabic ? "حفظ" : "Save")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default FormAddEditBlogTag;
